module.exports = __webpack_public_path__ + "img/lane-above.0210a07c.svg";